import { string } from "yup";
import api, { Notifiable, TipoOptions } from "../api";


export interface ICrfTipoDistribuicaoForcast {
    nome: string;
    id: string;
    codigo: number;
}


export const getAllTipoOptionTipoDistribuicaoForcast = () => {
    return api.get<Array<TipoOptions>>(`crfTipoDistribuicaoForcast/getAllTipoOptions`);
}

export const getAllCrfTipoDistribuicaoForcast = () => {
    return api.get<Array<ICrfTipoDistribuicaoForcast>>(`crfTipoDistribuicaoForcast/getAll`);
}





